import { useEffect } from 'react';

const tabableSelector = 'a[href], area[href], input:not([disabled]), '
  + 'button:not([disabled]),select:not([disabled]), textarea:not([disabled]), '
  + 'iframe, object, embed, *[tabindex]:not([tabindex^="-"]), *[contenteditable=true]';

const useTrapFocus = (
  elementRef: React.RefObject<HTMLDivElement>,
) => {
  useEffect(() => {
    // Trap the focus within the timezone selector popover
    const element = elementRef.current;
    const firstFocusable = element?.querySelector(tabableSelector);
    (firstFocusable as HTMLElement)?.focus();

    const trapFocus = (e) => {
      const focusableEls = element?.querySelectorAll(tabableSelector);
      const firstEl = focusableEls[0];
      const lastEl = focusableEls[focusableEls.length - 1];

      if (e.key === 'Tab') {
        if (e.shiftKey) {
          if (document.activeElement === firstEl) {
            e.preventDefault();
            (lastEl as HTMLElement)?.focus();
          }
        } else if (document.activeElement === lastEl) {
          e.preventDefault();
          (firstEl as HTMLElement)?.focus();
        }
      }
    };

    document.addEventListener('keydown', trapFocus);
    return () => document.removeEventListener('keydown', trapFocus);
  }, [elementRef]);
};

export default useTrapFocus;
